export enum EventType {
    INLINE_VISUALIZATION = "INLINE_VISUALIZATION",
    COMMAND = "COMMAND"
}

export enum ActionType {
    APPLY_HEATMAP_OVERLAY = "APPLY_HEATMAP_OVERLAY",
    ADD_SUMMARY_TABLE = "ADD_SUMMARY_TABLE",
    GENERATE_DASHBOARD = "GENERATE_DASHBOARD",
    DASHBOARD_WIDGET_EXPORT_PNG = "WIDGET_EXPORT_PNG",
    DASHBOARD_WIDGET_EXPORT_EXCEL = "WIDGET_EXPORT_EXCEL",
    DASHBOARD_WIDGET_REMOVE = "WIDGET_REMOVE",
    WIDGET_CREATE_NEW_OR_DUPLICATE = "WIDGET_CREATE_NEW_OR_DUPLICATE",
    NEW_DASHBOARD_NAVIGATE = "NEW_DASHBOARD_NAVIGATE"
}

export enum AgentType {
    HUMAN = "HUMAN",
    AI = "AI"
}

export const CHAT_INDEXED_DB_CONFIG = {
    DB_NAME: "ChatStorage",
    STORE_NAME: "UploadedFiles",
    FIELD_NAME: "imageData"
};